import { useTranslation } from 'react-i18next';
import { ContentContainer, StyledTypographyLarge } from './ui';

export type InformationContentProps = {
    updateCount: number;
    type: string;
};

const InformationContent = ({ updateCount, type }: InformationContentProps) => {
    const { t } = useTranslation('importExportExcel');

    return (
        <ContentContainer direction="horizontal">
            <StyledTypographyLarge>
                {t('importExportExcel:description.importSuccess', { totalCount: updateCount, type })}
            </StyledTypographyLarge>
        </ContentContainer>
    );
};

export default InformationContent;
